<template>
    <section
        v-if="posts.length"
        class="m-similar-posts"
    >
        <div class="m-similar-posts__title">
            <h3>
                {{ $t('blog.similar_articles_title') }}
            </h3>
        </div>
        <div class="m-similar-posts__posts">
            <template v-for="post in posts">
                <router-link
                    :key="post.id"
                    :to="{
                        name: 'blog-single',
                        params: {slug: post.slug}
                    }"
                    class="router-link-post"
                >
                    <y-blog-card
                        :post-data="post"
                    />
                </router-link>
            </template>
        </div>
    </section>
</template>

<script >
    import YBlogCard from '@modules/blog/components/Categories/BlogCard/BlogCard.vue';

    export default {
        name      : 'BlogSimilarPosts',
        components: {
            YBlogCard,
        },

        /**
         *
         * @inheritDoc
         */
        props: {
            posts: {
                type: Array,
            },
        },

    };

</script>

<style lang="scss" src="./similar-posts.scss"/>
